module.exports = __webpack_public_path__ + "static/img/ci@2x.5386a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/ci@2x.png
// module id = 5PHu
// module chunks = 2